import { HTMLAttributes, forwardRef, useEffect, useState, type ReactNode } from 'react'

// TODO: remove
export const ScreenHeightDiv = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ style, ...other }, ref): ReactNode => {
    const height = use100vh()
    const styleWithRealHeight = {
      ...style,
      height: height ? `${height}px` : '100vh',
    }

    return <div ref={ref} style={styleWithRealHeight} {...other} />
  },
)

ScreenHeightDiv.displayName = 'ScreenHeightDiv'

function use100vh(): number | null {
  const [height, setHeight] = useState<number | null>(measureHeight)

  const wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce()

  useEffect(() => {
    if (!wasRenderedOnClientAtLeastOnce) return

    function setMeasuredHeight(): void {
      const measuredHeight = measureHeight()
      setHeight(measuredHeight)
    }

    window.addEventListener('resize', setMeasuredHeight)
    return (): void => {
      window.removeEventListener('resize', setMeasuredHeight)
    }
  }, [wasRenderedOnClientAtLeastOnce])
  return wasRenderedOnClientAtLeastOnce ? height : null
}

function measureHeight(): number | null {
  if (!isClient()) return null
  return window.innerHeight
}

function useWasRenderedOnClientAtLeastOnce(): boolean {
  const [wasRenderedOnClientAtLeastOnce, setWasRenderedOnClientAtLeastOnce] = useState(false)

  useEffect(() => {
    if (isClient()) {
      setWasRenderedOnClientAtLeastOnce(true)
    }
  }, [])
  return wasRenderedOnClientAtLeastOnce
}

function isClient(): boolean {
  return globalThis.window !== undefined && typeof document !== 'undefined'
}
